import React from 'react';
import './Info.css';

export default function Info() {
  return (
    <div>
      <div className="home-container small-width">
        <div className="container">
          <ul className="info-links">
            <li>
              <a href="https://www.instagram.com/thingdoms/" className="title-link-secondary" target="_blank" rel="noopener noreferrer">
                <span className="title-text-secondary">Instagram</span>
              </a>
            </li>
            <li>
              <a href="https://x.com/thingdoms" className="title-link-secondary" target="_blank" rel="noopener noreferrer">
                <span className="title-text-secondary">Twitter / X</span>
              </a>
            </li>
            <li>
              <a href="https://opensea.io/collection/thingdoms" className="title-link-secondary" target="_blank" rel="noopener noreferrer">
                <span className="title-text-secondary">OpenSea</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
